import React from 'react';
import PropTypes from 'prop-types';

import JobName from './job_name/JobName';

const JobTitle = (props) => {
  const {jobData, client, jobBackend} = props;

  return (
    <JobName
      jobData={jobData}
      client={client}
      jobBackend={jobBackend}
    />
  );
};
JobTitle.propTypes = {
  jobData: PropTypes.object.isRequired,
  client: PropTypes.object,
  jobBackend: PropTypes.object.isRequired,
};

export default React.memo(JobTitle);
